import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"
import Content from "../components/content"
// import CallToAction from "../components/cta"
import Resources from "../components/resources"
import LogRocket from 'logrocket';

LogRocket.init('bz2adh/max-and-milo-book');

const IndexPage = () => (
  <Layout>
    <SEO />
    <Hero />
    <Content />
    <Resources />
    {/* <CallToAction /> */}
  </Layout>
)

export default IndexPage
